import { render, staticRenderFns } from "./transitPage.vue?vue&type=template&id=3f7c41b5&scoped=true&"
import script from "./transitPage.vue?vue&type=script&lang=js&"
export * from "./transitPage.vue?vue&type=script&lang=js&"
import style0 from "./transitPage.vue?vue&type=style&index=0&id=3f7c41b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7c41b5",
  null
  
)

export default component.exports